import React from 'react';
import { SelectFieldv2 as SelectField } from 'components';
import type { SelectFieldOptionObject as LanguageOption } from 'components/v2/SelectField/types';

import './LanguageSelector.scss';

export interface LanguageSelectorProps {
  id: string;
  selectedLanguage: string;
  availableLanguages: LanguageOption[];
  onLanguageChange: (languageCode: string) => void;
  disabled?: boolean;
  placeholder?: string;
}

const LanguageSelector: React.FC<LanguageSelectorProps> = ({
  id,
  selectedLanguage,
  availableLanguages,
  onLanguageChange,
  disabled = false,
  placeholder = 'Select language...',
}) => {
  const selectedOption = availableLanguages.find(
    lang => lang.value === selectedLanguage
  );

  const handleChange = (option: LanguageOption | null) => {
    if (option) {
      onLanguageChange(option.value);
    }
  };

  return (
    <div className="language-selector">
      <SelectField
        controlledValue={selectedOption}
        options={availableLanguages}
        onChange={handleChange}
        id={id}
        placeholder={placeholder}
        isDisabled={disabled}
        isClearable={false}
        isSearchable={false}
        isMulti={false}
        menuPlacement="auto"
      />
    </div>
  );
};

export default LanguageSelector;
